import React from 'react';

interface SectionHeadingProps {
  className?: string;
  children: React.ReactNode;
}

export const SectionHeading: React.FC<SectionHeadingProps> = ({ className = '', children }) => (
  <div className={`flex items-center gap-4 ${className}`}>
    <span className="label-caps text-ink-faint whitespace-nowrap">{children}</span>
    <span className="h-px flex-1 bg-line" />
  </div>
);
